<div class="flex-center">
	<div class="p-relative flex-center">
		<div *ngIf="loading" class="image-loading flex-center">
			<app-spinner [color]="'grey'" [scale]="0.7"></app-spinner>
		</div>
		<img *ngIf="!loading" [src]="logo" alt="" [style.width.px]="size" [style.height.px]="size" [style.border-radius.px]="size / 4">
	</div>
</div>
